<div class="logo" style="margin-bottom: 20px">
  <img src="assets/logoRegister.png" class="imgLogo" alt="Previdas Logo" />
</div>

<div style="padding: 30px; text-align: center" class="card">
  <h2>Cadastro realizado com sucesso!</h2>
  <p>Bem-vindo à Previdas.</p>
  <p>
    Em alguns minutos você receberá um e-mail com instruções para criar o
    primeiro usuário e definir a senha de acesso ao sistema.
  </p>
  <p>Verifique sua caixa de entrada e, se necessário, sua pasta de spam.</p>

  <a mat-button class="btn-green btn-large" [routerLink]="['/', 'login']">
    <span>Voltar ao login</span>
  </a>
</div>
